import axios from 'axios';

import cfac22 from '../cfac22';

/**
 * Busca um usuário na rota de usuários dos microserviços.
 *
 * @param {Object} params
 * @param {string} params.identifier - Identificador do usuário, normalmente o UID.
 * @param {string|null} params.partnerId - Identificador do parceiro.
 * @param {string} params.type - Tipo do identificador (uid, cellphone ou cpf).
 * @param {boolean} [params.userV3=true] - Solicita os dados do usuário V3.
 * @param {boolean} [params.financial=true] - Solicita os dados financeiros.
 * @returns {Promise<Object>} O objeto `result` retornado pela API.
 */
export async function getUserData({
  identifier,
  partnerId,
  type,
  userV3 = false,
  financial = false,
}) {
  try {
    const response = await axios.get(`${cfac22('MICROSERVICES')}/user`, {
      params: {
        identifier,
        partnerId,
        type,
        userV3,
        financial,
      },
      headers: {
        'Full-Url': window.location.href,
      },
      withCredentials: true,
    });

    const { success, result, error } = response.data || {};

    if (!success) {
      throw new Error(error || 'Erro ao buscar informações do usuário');
    }

    return result;
  } catch (error) {
    throw error?.response?.data || error;
  }
}

